import { render, staticRenderFns } from "./tutorial-slide.vue?vue&type=template&id=f56f07b2"
import script from "./tutorial-slide.vue?vue&type=script&lang=js"
export * from "./tutorial-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports